import { j as e } from "../../jsx-runtime-B6kdoens.js";
import { c as s } from "../../index-CROKJrb5.js";
import { c as p, f as b } from "../../create-component-CBAeEoQ6.js";
import { Typography as f } from "../Typography/index.js";
const x = s({
  base: "[&>*]:cur-flex",
  variants: {
    divider: {
      true: "cur-border-b-2 cur-border-border-secondary"
    }
  }
}), h = s({
  base: "cur-items-start cur-justify-between",
  variants: {
    size: {
      sm: "cur-mb-1",
      lg: "cur-mb-[.375rem]"
    }
  }
}), C = p(
  "ListHeader",
  b(
    ({
      as: t,
      divider: a = !0,
      meta: o,
      size: r = "lg",
      headerTitle: c,
      className: i,
      ...m
    }, n) => {
      const d = t || "div", l = r === "sm" ? "body" : "h3", u = r === "sm" ? "normal" : "bold";
      return /* @__PURE__ */ e.jsx(
        d,
        {
          ref: n,
          className: x({ className: i, divider: a }),
          ...m,
          children: /* @__PURE__ */ e.jsxs("div", { className: h({ size: r }), children: [
            /* @__PURE__ */ e.jsx(f, { size: l, weight: u, children: c }),
            /* @__PURE__ */ e.jsx("div", { className: "cur-flex cur-items-start cur-text-meta", children: o })
          ] })
        }
      );
    }
  )
);
export {
  C as ListHeader
};
//# sourceMappingURL=index.js.map
